import { LoremIpsumWidgetSchemaKey } from '@inference.engine/widgets/web';
import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import { LoremIpsumWidget } from '@inference.engine/widgets';

/**
 * Factory that binds the LoremIpsum widget processor to the supplied dep
 * surface. Returns the processor list consumed by the central widget
 * dispatcher in `features/widgets/processors/`.
 *
 * The widget slice MUST NOT
 * value-import `widgetProcessorDeps` from `@/features/widgets/processors/...`
 * (that would be a cross-feature OUT). The dispatcher (which owns the deps
 * binding) calls this factory and supplies the deps.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<LoremIpsumWidget>> = {
    key: LoremIpsumWidgetSchemaKey,
    processor: makeCreateWidgetAction(deps),
  };
  return [create];
};
